<template>
  <div class="pager" v-if="page.totalElements > 0">
    <div class="pager__size">
      <span>Sayfa Başına</span>
      <select
        v-model="pageSize"
        class="pager__size-select"
        id="pager__size-select"
        @change="setPageSizes($event.target.value)"
      >
        <option value="5">5</option>
        <option value="10">10</option>
        <option value="20">20</option>
        <option value="50">50</option>
        <option value="100">100</option>
      </select>
      <span>satır</span>
    </div>
    <ul class="pager__items">
      <li class="pager__item-text">
        <a
          id="controls-first-page"
          :class="{ disabled: page.pageNumber === 1 }"
          @click="setPage(1)"
        >
          <base-icon name="controls-first-page" />
        </a>
      </li>
      <li class="pager__item-text">
        <a
          id="controls-backward"
          :class="{ disabled: page.pageNumber === 1 }"
          @click="setPage(page.pageNumber - 1)"
        >
          <base-icon name="controls-backward" />
        </a>
      </li>
    </ul>
    <ul
      class="pager__items overflow-settings"
      :class="{ disableScroll: page.totalPages <= 3 }"
    >
      <li
        v-for="n in page.totalPages"
        :key="n"
        class="pager__item-number"
        :class="{ active: page.pageNumber === n }"
      >
        <span :id="'pager__item-number-' + n" @click="setPage(n)">{{ n }}</span>
      </li>
    </ul>
    <ul class="pager__items">
      <li class="pager__item-text">
        <a
          id="controls-forward"
          :class="{ disabled: page.pageNumber === page.totalPages }"
          @click="setPage(page.pageNumber + 1)"
        >
          <base-icon name="controls-forward" />
        </a>
      </li>
      <li class="pager__item-text">
        <a
          id="controls-last-page"
          :class="{ disabled: page.pageNumber === page.totalPages }"
          @click="setPage(page.totalPages)"
        >
          <base-icon name="controls-last-page" />
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
import { BaseIcon } from "@/components";

export default {
  name: "Pager",
  components: {
    BaseIcon,
  },
  props: {
    page: Object,
    pageName: String,
  },
  data() {
    return {
      pageSize: this.$route.name == "UsersRole" ? 10 : 100,
      customerId: null,
      changedXlsxData: [],
    };
  },
  computed: {
    ...mapGetters(["generalFilter", "userRoleFilter"]),
  },
  methods: {
    ...mapActions([
      "getAllPackages",
      "getHistoryList",
      "getRepresentativeReport",
      "getInvoiceList",
      "userRoleGetUsersList",
    ]),
    ...mapMutations([
      "setGeneralFilter",
      "setInvoiceFilter",
      "setUserRoleFilter",
    ]),
    setPage(page) {
      page = parseInt(page);
      this.setGeneralFilter({ page: page, size: Number(this.pageSize) });
      this.setInvoiceFilter({ page: page, size: Number(this.pageSize) });
      this.setUserRoleFilter({ page: page, size: Number(this.pageSize) });

      if (this.pageName == "dataRequest") {
        const customerId = this.$route.params.customerId;
        this.getAllPackages(customerId).then(() => {
          this.scroll();
        });
      } else if (this.pageName == "history") {
        this.getHistoryList(this.customerId).then(() => {
          this.scroll();
        });
      } else if (this.pageName == "represReports") {
        this.$emit("changedData");
        this.getRepresentativeReport((response) => {
          this.scroll();
          this.$emit("changedData", response.data);
        });
      } else if (this.pageName == "invoice") {
        this.getInvoiceList(this.customerId).then(() => {
          this.scroll();
        });
      } else if (this.pageName === "usersRole") {
        this.getUserList();
      }
    },
    getUserList() {
      this.userRoleGetUsersList().then((response) => {
        if (response.error) {
          this.$toast.error(response.message);
        } else {
          if (response.data.length > 0) {
            this.$emit("refreshUsersRole", {
              response: response,
              headers: Object.keys(response.data[0]),
            });
          } else {
            this.$emit("refreshUsersRole", {
              response: response,
              headers: [],
            });
          }
        }
      });
    },
    setPageSizes(selectedValue) {
      const selectedNumber = parseInt(selectedValue);
      this.pageSize = selectedNumber;
    },
    scroll() {
      const el = document.getElementById("content");
      const topData = document.getElementById(this.pageName);
      el.scrollTo({
        top: topData.offsetTop,
        left: 0,
        behavior: "smooth",
      });
    },
  },
  beforeDestroy() {
    this.setUserRoleFilter({ page: 1, size: 20 });
  },
  watch: {
    pageSize() {
      this.setGeneralFilter({
        page: this.generalFilter.page,
        size: Number(this.pageSize),
      });
      this.setInvoiceFilter({
        page: this.generalFilter.page,
        size: Number(this.pageSize),
      });

      if (this.pageName === "dataRequest") {
        const customerId = this.$route.params.customerId;
        this.getAllPackages(customerId);
      } else if (this.pageName === "history") {
        this.getHistoryList(this.customerId);
      } else if (this.pageName === "represReports") {
        this.$emit("changedData");
        this.getRepresentativeReport((response) => {
          this.$emit("changedData", response.data);
        });
      } else if (this.pageName === "invoice") {
        this.getInvoiceList(this.customerId);
      } else if (this.pageName == "usersRole") {
        this.setUserRoleFilter({
          page: 1,
          size: Number(this.pageSize),
        });
        this.userRoleGetUsersList().then((response) => {
          if (response.error) {
            this.$toast.error(response.message);
          } else {
            if (response.data.length > 0) {
              this.$emit("refreshUsersRole", {
                response: response,
                headers: Object.keys(response.data[0]),
              });
            } else {
              this.setUserRoleFilter({
                page: 1,
                size: 10,
              });
              this.getUserList();
            }
          }
        });
      }
    },
  },
  mounted() {
    this.customerId = this.$route.params.customerId;
    if (this.$route.name == "UsersRole") {
      this.setPageSizes(10);
    }
  },
};
</script>

<style lang="scss" scoped>
.pager {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  font-size: 14px;
  margin-top: 20px;
  @media (max-width: 493px) {
    justify-content: center;
  }
  .disabled {
    pointer-events: none;
  }
  &__size,
  &__items {
    display: flex;
    align-items: center;
  }
  &__size {
    margin-right: 30px;
    @media (max-width: 493px) {
      margin: 10px 0 20px 0;
      width: 100%;
      justify-content: center;
    }
    span {
      padding: 0 12px;
    }
  }
  &__items {
    list-style: none;
    &.overflow-settings {
      max-width: 300px;
      overflow-x: scroll;
      background: linear-gradient(
        to left,
        transparent,
        transparent 0%,
        #e1e1e1e1 100%,
        transparent 20%
      );
    }
    &.disableScroll::-webkit-scrollbar {
      display: none;
    }
  }
  &__item-number {
    color: var(--grayscale-70);
    cursor: pointer;
    span {
      padding: 11px 16px;
      display: block;
    }
    &.disabled {
      color: var(--grayscale-50);
    }
    &.active {
      background-color: var(--color-primary-default);
      color: var(--grayscale-0);
      border-radius: var(--radius-first);
    }
  }
  &__item-text {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  &__size-select {
    width: 74px;
    height: 40px;
    padding-left: 7px;
    border-radius: var(--radius-first);
    border-color: var(--grayscale-50);
  }
}
</style>
